import { I18n } from '@calendly/i18n';
import { SwitchInput } from '@calendly/ui/components/switch-input';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useSelector } from 'react-redux';
import { EnforcementSubtitle } from 'features/organization_settings/shared/styles';
import { useBooleanState } from 'hooks/useBooleanState';
import { EnforcementPopup } from './enforcement_popup';
import { ssoEnforcedSelector } from './selectors';
const switchCss = "sy8fkf9";
const Switch = forwardRef((props, ref) => <SwitchInput ref={ref} {...props} className={classNames(switchCss, props.className)} />);
export const Enforcement = () => {
  const [isPopupOpen, openPopup, closePopup] = useBooleanState(false);
  const isEnforced = useSelector(ssoEnforcedSelector);
  return <>
      <EnforcementSubtitle>{I18n.t('publisher.organization_settings.sso.enforcement.subtitle')}</EnforcementSubtitle>
      <p>{I18n.t('publisher.organization_settings.sso.enforcement.description')}</p>
      <label>
        <Switch checked={isEnforced} onChange={openPopup} />
        {I18n.t('publisher.organization_settings.sso.enforcement.switch')}
      </label>
      {isPopupOpen && <EnforcementPopup onClose={closePopup} />}
    </>;
};

require("./enforcement.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./enforcement.js");